"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TectonicCoreBorkedFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TectonicSocket",
                name: "unitroller",
                type: "address",
            },
            {
                internalType: "contract PriceOracle",
                name: "_oracle",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_closeFactorMantissa",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_maxAssets",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "_reinitializing",
                type: "bool",
            },
        ],
        name: "_become",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b506101eb806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c806332000e0014610030575b600080fd5b610074600480360360a081101561004657600080fd5b506001600160a01b038135811691602081013590911690604081013590606081013590608001351515610076565b005b846001600160a01b031663f851a4406040518163ffffffff1660e01b815260040160206040518083038186803b1580156100af57600080fd5b505afa1580156100c3573d6000803e3d6000fd5b505050506040513d60208110156100d957600080fd5b50516001600160a01b031633146101215760405162461bcd60e51b81526004018080602001828103825260278152602001806101906027913960400191505060405180910390fd5b846001600160a01b031663c1e803346040518163ffffffff1660e01b8152600401602060405180830381600087803b15801561015c57600080fd5b505af1158015610170573d6000803e3d6000fd5b505050506040513d602081101561018657600080fd5b5050505050505056fe6f6e6c7920756e6974726f6c6c65722061646d696e2063616e206368616e676520627261696e73a265627a7a7231582017b129263bf945ede1045de88f62644835744acacd9ea3947fb8b16fbbef9ae564736f6c63430005100032";
class TectonicCoreBorkedFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TectonicCoreBorkedFactory = TectonicCoreBorkedFactory;
TectonicCoreBorkedFactory.bytecode = _bytecode;
TectonicCoreBorkedFactory.abi = _abi;
//# sourceMappingURL=TectonicCoreBorkedFactory.js.map